import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, logEvent, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAUAScaVBp5fLzmd-XK9nRG1SBiprR3J_s",
  authDomain: "rosemount-financial-solu-4f940.firebaseapp.com",
  projectId: "rosemount-financial-solu-4f940",
  storageBucket: "rosemount-financial-solu-4f940.appspot.com",
  messagingSenderId: "9919024994",
  appId: "1:9919024994:web:341936e0cdfd6dc894a63b",
  measurementId: "G-FWGGDN8B28",
};

// Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyA9L5ybddT1yyBTlNnlMX8R-CcjXUlKVfA",
//   authDomain: "rosemount-financial-solutions.firebaseapp.com",
//   projectId: "rosemount-financial-solutions",
//   storageBucket: "rosemount-financial-solutions.appspot.com",
//   messagingSenderId: "841729471123",
//   appId: "1:841729471123:web:3a09a54683d508e1555366"
// };

// Initialize Firebase app
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);
// logEvent(analytics, "page_view", { debug_mode: true });
// logEvent(analytics, "page_view");


export { auth, db, storage };
